import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "house-check-container app-page app-page--fill" }
const _hoisted_2 = { class: "list-header" }
const _hoisted_3 = { class: "check-list-wrapper" }
const _hoisted_4 = {
  class: "right-panel",
  "element-loading-text": "加载中..."
}
const _hoisted_5 = {
  key: 0,
  class: "edit-area"
}
const _hoisted_6 = { class: "edit-mode-control" }
const _hoisted_7 = { class: "left-actions" }
const _hoisted_8 = {
  key: 0,
  class: "right-actions"
}
const _hoisted_9 = { class: "basic-info-section" }
const _hoisted_10 = { class: "tabs-container" }
const _hoisted_11 = { class: "tab-designer" }
const _hoisted_12 = {
  key: 0,
  class: "designer-toolbar"
}
const _hoisted_13 = { class: "elements-list" }
const _hoisted_14 = {
  key: 0,
  class: "empty-elements"
}
const _hoisted_15 = { class: "element-preview-area" }
const _hoisted_16 = { class: "element-label" }
const _hoisted_17 = { class: "element-control-wrapper" }
const _hoisted_18 = {
  key: 3,
  style: {"width":"100%"}
}
const _hoisted_19 = {
  key: 0,
  class: "checkbox-split-view"
}
const _hoisted_20 = { class: "split-column required-column" }
const _hoisted_21 = { class: "column-body" }
const _hoisted_22 = { class: "split-column optional-column" }
const _hoisted_23 = { class: "column-body" }
const _hoisted_24 = {
  key: 0,
  class: "element-actions"
}
const _hoisted_25 = { class: "action-btn-list" }
const _hoisted_26 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_27 = { class: "options-designer" }
const _hoisted_28 = ["onDragstart", "onDragover", "onDrop"]
const _hoisted_29 = { class: "options-designer" }
const _hoisted_30 = ["onDragstart", "onDragover", "onDrop"]
const _hoisted_31 = { class: "options-designer" }
const _hoisted_32 = ["onDragstart", "onDragover", "onDrop"]
const _hoisted_33 = { class: "dialog-footer" }

import { ref, computed, onMounted, nextTick, onUnmounted, watchEffect } from 'vue';
import { 
  Plus, Refresh, Edit, Close, DocumentChecked, 
  RefreshLeft, ArrowUp, ArrowDown, EditPen, Delete, Minus, Rank
} from '@element-plus/icons-vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import DynamicTable from '@/components/DynamicTable.vue';
import { ParameterSettings } from '@/network/index';

// 定义体检定义数据接口
interface HouseCheckElement {
  id: string;
  name: string;
  type: 'text' | 'number' | 'radio' | 'checkbox' | 'textarea';
  options: string[];
  optionalOptions?: string[];
  placeholder?: string;
}

interface HouseCheckData {
  id?: number | string;
  name: string;
  tabsData: Record<string, HouseCheckElement[]>;
}

// 5个固定页签，做成数组循环渲染，方便后续增减更改
const minPanelWidth = 220;


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const tabList = [
  { key: 'basicInfo', label: '房屋基本信息' },
  { key: 'siteEnv', label: '场地环境及地基基础' },
  { key: 'mainStruct', label: '主体机构' }, // 保持与用户需求“主体机构”字样一致
  { key: 'envelopeSys', label: '围护系统' },
  { key: 'equipment', label: '设备设施及管线' }
];

// 所属类别双向映射
const categoryToTabKey: Record<string, string> = {
  '1房屋基础信息': 'basicInfo',
  '2场地环境及地基基础': 'siteEnv',
  '3主体机构': 'mainStruct',
  '4围护系统': 'envelopeSys',
  '5设备设施及管线': 'equipment'
};

const tabKeyToCategory: Record<string, string> = {
  'basicInfo': '1房屋基础信息',
  'siteEnv': '2场地环境及地基基础',
  'mainStruct': '3主体机构',
  'envelopeSys': '4围护系统',
  'equipment': '5设备设施及管线'
};

// 数据类型双向映射
const typeToBackend: Record<string, string> = {
  'text': '文本',
  'number': '数字',
  'radio': '选项',
  'checkbox': '多选',
  'textarea': '文本域'
};

const backendToType: Record<string, string> = {
  '文本': 'text',
  '数字': 'number',
  '选项': 'radio',
  '多选': 'checkbox',
  '文本域': 'textarea'
};

// 双向转换函数：后端数据结构 -> 前端数据结构
const transformBackendToCheckData = (backendData: any): HouseCheckData => {
  const emptyTabsData: Record<string, HouseCheckElement[]> = {};
  tabList.forEach(tab => {
    emptyTabsData[tab.key] = [];
  });

  const fieldList = backendData.房屋建筑定期体检数据采集模板字段表集合 || [];
  fieldList.forEach((field: any) => {
    const tabKey = categoryToTabKey[field.所属类别] || 'basicInfo';
    emptyTabsData[tabKey].push({
      id: String(field.Id || 'elem_' + Date.now().toString().slice(-6) + Math.random().toString().slice(-2)),
      name: field.字段名称,
      type: (backendToType[field.数据类型] as any) || 'text',
      options: field.必选项 || [],
      optionalOptions: field.可选项 || [],
      placeholder: field.预显备注 || ''
    });
  });

  return {
    id: backendData.Id || '',
    name: backendData.名称 || '',
    tabsData: emptyTabsData
  };
};

// 双向转换函数：前端数据结构 -> 后端数据结构
const transformCheckDataToBackend = (frontendData: HouseCheckData): any => {
  const fieldCollection: any[] = [];
  
  let fieldIndex = 0;
  tabList.forEach(tab => {
    const elements = frontendData.tabsData[tab.key] || [];
    elements.forEach((elem) => {
      fieldCollection.push({
        "字段名称": elem.name,
        "所属类别": tabKeyToCategory[tab.key],
        "数据类型": typeToBackend[elem.type] || '文本',
        "必选项": elem.options || [],
        "必选项JSON": JSON.stringify(elem.options || []),
        "可选项": elem.optionalOptions || [],
        "可选项JSON": JSON.stringify(elem.optionalOptions || []),
        "预显备注": elem.placeholder || '',
        "index": fieldIndex++,
        "Id": isNaN(Number(elem.id)) ? 0 : Number(elem.id)
      });
    });
  });

  return {
    "名称": frontendData.name,
    "最后修改人": "",
    "版本": "1.0",
    "实施日期": new Date().toISOString(),
    "ISDELETED": false,
    "房屋建筑定期体检数据采集模板字段表集合": fieldCollection,
    "Id": isNaN(Number(frontendData.id)) ? 0 : Number(frontendData.id)
  };
};

// 左侧面板拖拽调整宽度相关
const mainContentRef = ref<HTMLElement | null>(null);
const leftPanelRef = ref<HTMLElement | null>(null);
const leftPanelWidth = ref<string>('30%');
const isResizing = ref<boolean>(false);
const startResize = (e: MouseEvent) => {
  isResizing.value = true;
  document.addEventListener('mousemove', handleResize);
  document.addEventListener('mouseup', stopResize);
  document.body.style.cursor = 'col-resize';
  document.body.style.userSelect = 'none';
};

const handleResize = (e: MouseEvent) => {
  if (!isResizing.value || !mainContentRef.value) return;
  const containerRect = mainContentRef.value.getBoundingClientRect();
  const maxWidth = containerRect.width / 2;
  let newWidth = e.clientX - containerRect.left;
  newWidth = Math.max(minPanelWidth, Math.min(maxWidth, newWidth));
  leftPanelWidth.value = newWidth + 'px';
};

const stopResize = () => {
  isResizing.value = false;
  document.removeEventListener('mousemove', handleResize);
  document.removeEventListener('mouseup', stopResize);
  document.body.style.cursor = '';
  document.body.style.userSelect = '';
};

// 列表及分页配置
const listLoading = ref<boolean>(false);
const detailLoading = ref<boolean>(false);
const saveLoading = ref<boolean>(false);
const isEditMode = ref<boolean>(false);

const activeTab = ref<string>('basicInfo');

const checkTableModel = ref<Record<string, string>>({
  Id: 'String',
  名称: 'String',
  最后修改人: 'String',
  版本: 'String',
  实施日期: 'String'
});

const checkTableLabels = ref<Record<string, string>>({
  Id: '模板ID',
  名称: '报告模板名称',
  最后修改人: '最后修改人',
  版本: '版本',
  实施日期: '实施日期'
});

const checkPagination = ref({
  page: 1,
  pageSize: 15,
  total: 0,
  show: true
});

// 本次编辑的房屋体检项
const currentCheck = ref<HouseCheckData | null>(null);
const checkFormRef = ref<any>(null);
const checkFormRules = {
  name: [
    { required: true, message: '请输入房屋体检报告名称', trigger: 'blur' }
  ]
};

// 当前选中行 key
const activeCheckRowKey = computed(() => {
  return currentCheck.value?.id ? String(currentCheck.value.id) : '';
});

// 🌟 契合 DynamicTable 与后端列表接口的多重过滤筛选参数
const filterParams = ref<any[]>([]);
const allCheckList = ref<HouseCheckData[]>([]);

// 加载房屋体检定义列表
const loadCheckList = async () => {
  listLoading.value = true;
  try {
    const paginationData = {
      page: checkPagination.value.page,
      intPageSize: checkPagination.value.pageSize
    };
    const res = await ParameterSettings.houseCheckListIndex(
      paginationData,
      filterParams.value
    );
    if (res && res.status === 200 && res.success && res.response) {
      const responseData = Array.isArray(res.response) ? res.response : (res.response.data || []);
      allCheckList.value = responseData.map((item: any) => {
        return {
          id: item.Id || item.id,
          name: item.名称 || item.name,
          Id: item.Id || item.id,
          名称: item.名称 || item.name,
          最后修改人: item.最后修改人 || '-',
          版本: item.版本 || '-',
          实施日期: item.实施日期 ? item.实施日期.replace('T', ' ') : '-',
          tabsData: {}
        };
      });
      if (res.response.model && typeof res.response.model === 'object') {
        checkTableModel.value = res.response.model;
      }
      // 同步后端分页信息
      checkPagination.value.total = res.response.dataCount || 0;
      if (res.response.pageCount) {
        checkPagination.value.page = res.response.page || checkPagination.value.page;
      }
    } else {
      allCheckList.value = [];
    }
  } catch (error) {
    console.error('加载房屋体检定义列表失败:', error);
    ElMessage.error('加载列表失败');
  } finally {
    listLoading.value = false;
  }
};

// 获取某个页签下的表单元素数组
const getCurrentTabElements = (tabKey: string): HouseCheckElement[] => {
  if (!currentCheck.value || !currentCheck.value.tabsData) return [];
  return currentCheck.value.tabsData[tabKey] || [];
};

// 列表筛选
const handleFilter = (filters: any[]) => {
  filterParams.value = filters;
  checkPagination.value.page = 1;
  loadCheckList();
};

// 分页改变
const handleCheckPageChange = (page: number) => {
  checkPagination.value.page = page;
  loadCheckList();
};

const handleCheckPageSizeChange = (pageSize: number) => {
  checkPagination.value.pageSize = pageSize;
  checkPagination.value.page = 1;
  loadCheckList();
};

// 新增房屋体检定义项
const addNewCheck = () => {
  // 生成空的基础结构，初始化 5 个页签的空数组
  const emptyTabsData: Record<string, HouseCheckElement[]> = {};
  tabList.forEach(tab => {
    emptyTabsData[tab.key] = [];
  });

  currentCheck.value = {
    id: '', // 新建无 ID
    name: '新建房屋体检定义_' + (allCheckList.value.length + 1),
    tabsData: emptyTabsData
  };
  
  isEditMode.value = true; // 新增默认进入编辑模式
  activeTab.value = 'basicInfo'; // 默认定位到第一个页签
};

// 查看/编辑体检定义项详情
const handleCheckEdit = async (row: any) => {
  const itemId = row.id || row.Id;
  if (!itemId) return;

  detailLoading.value = true;
  try {
    const res = await ParameterSettings.houseCheckById({ id: itemId });
    if (res && res.status === 200 && res.success && res.response) {
      currentCheck.value = transformBackendToCheckData(res.response);
      isEditMode.value = false; // 默认是查看模式
    } else {
      ElMessage.error('加载详情失败');
    }
  } catch (error) {
    console.error('加载详情失败:', error);
    ElMessage.error('加载详情失败');
  } finally {
    detailLoading.value = false;
  }
};

// 删除体检定义项
const handleCheckDelete = (row: any) => {
  const itemId = row.id || row.Id;
  if (!itemId) return;

  ElMessageBox.confirm(`确定要删除房屋体检定义项 "${row.name}" 吗？`, '警告', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(async () => {
    try {
      const res = await ParameterSettings.houseCheckDelete({ id: itemId });
      if (res && res.status === 200 && res.success) {
        ElMessage.success('删除成功');
        // 如果删除的是当前选中的，清空右侧详情
        if (currentCheck.value && String(currentCheck.value.id) === String(itemId)) {
          currentCheck.value = null;
          isEditMode.value = false;
        }
        await loadCheckList();
      } else {
        ElMessage.error(res.message || '删除失败');
      }
    } catch (error) {
      console.error('删除失败:', error);
      ElMessage.error('删除失败');
    }
  }).catch(() => undefined);
};

// 进入编辑模式
const enterEditMode = () => {
  if (currentCheck.value) {
    // 拷贝一份备份，用来取消编辑时恢复
    (currentCheck.value as any)._backup = JSON.parse(JSON.stringify(currentCheck.value));
    isEditMode.value = true;
  }
};

// 取消编辑并退回查看
const exitEditMode = () => {
  if (currentCheck.value) {
    if ((currentCheck.value as any)._backup) {
      // 还原备份
      const backup = (currentCheck.value as any)._backup;
      currentCheck.value = backup;
      delete (currentCheck.value as any)._backup;
    } else if (!currentCheck.value.id) {
      // 如果是新增状态，直接取消则清空右侧
      currentCheck.value = null;
    }
  }
  isEditMode.value = false;
};

// 重置当前正在编辑的数据
const resetCurrentCheck = () => {
  if (currentCheck.value) {
    if ((currentCheck.value as any)._backup) {
      const backup = (currentCheck.value as any)._backup;
      // 保持 backup，但重置当前值为深拷贝的 backup 副本
      currentCheck.value = JSON.parse(JSON.stringify(backup));
    } else {
      // 新增状态重置
      const emptyTabsData: Record<string, HouseCheckElement[]> = {};
      tabList.forEach(tab => {
        emptyTabsData[tab.key] = [];
      });
      currentCheck.value.name = '';
      currentCheck.value.tabsData = emptyTabsData;
    }
    ElMessage.info('重置成功');
  }
};

// 保存体检定义数据
const saveCheckData = async () => {
  if (!checkFormRef.value) return;
  
  await checkFormRef.value.validate(async (valid: boolean) => {
    if (valid) {
      saveLoading.value = true;
      try {
        const backendPayload = transformCheckDataToBackend(currentCheck.value!);
        const res = await ParameterSettings.houseCheckSave(backendPayload);
        if (res && res.status === 200 && res.success) {
          ElMessage.success('保存成功');
          isEditMode.value = false;
          await loadCheckList(); // 重新加载列表
          
          // 重新加载选中的详情数据
          const savedId = res.response?.Id || res.response?.id || backendPayload.Id;
          if (savedId) {
            const foundItem = allCheckList.value.find(item => String(item.id) === String(savedId));
            if (foundItem) {
              await handleCheckEdit(foundItem);
            } else {
              currentCheck.value = null;
            }
          } else {
            currentCheck.value = null;
          }
        } else {
          ElMessage.error(res.message || '保存失败');
        }
      } catch (e) {
        console.error('保存失败:', e);
        ElMessage.error('保存失败');
      } finally {
        saveLoading.value = false;
      }
    } else {
      ElMessage.warning('请填写必填项后再保存');
    }
  });
};

// ==========================================
// 动态表单设计器相关操作
// ==========================================

const elementDialogVisible = ref<boolean>(false);
const elementFormRef = ref<any>(null);
const isEditingElement = ref<boolean>(false);
const currentEditingTabKey = ref<string>('');
const currentEditingElementIndex = ref<number>(-1);

// 表单元素编辑模型
const elementForm = ref<{
  name: string;
  type: 'text' | 'number' | 'radio' | 'checkbox' | 'textarea';
  options: string[]; // 单选选项/多选必选项
  optionalOptions: string[]; // 多选可选项
  placeholder: string;
}>({
  name: '',
  type: 'text',
  options: ['', ''],
  optionalOptions: [],
  placeholder: ''
});

const elementFormRules = {
  name: [
    { required: true, message: '请输入表单名称', trigger: 'blur' }
  ],
  type: [
    { required: true, message: '请选择表单类型', trigger: 'change' }
  ]
};

// 打开添加表单元素的弹窗
const openAddElementDialog = (tabKey: string) => {
  currentEditingTabKey.value = tabKey;
  isEditingElement.value = false;
  currentEditingElementIndex.value = -1;
  
  elementForm.value = {
    name: '',
    type: 'text',
    options: ['', ''],
    optionalOptions: [],
    placeholder: ''
  };
  
  elementDialogVisible.value = true;
  nextTick(() => {
    if (elementFormRef.value) {
      elementFormRef.value.clearValidate();
    }
  });
};

// 打开编辑已有表单元素的弹窗
const openEditElementDialog = (tabKey: string, index: number) => {
  currentEditingTabKey.value = tabKey;
  isEditingElement.value = true;
  currentEditingElementIndex.value = index;
  
  const element = currentCheck.value!.tabsData[tabKey][index];
  elementForm.value = {
    name: element.name,
    type: element.type,
    options: element.options && element.options.length > 0 ? [...element.options] : ['', ''],
    optionalOptions: element.optionalOptions ? [...element.optionalOptions] : [],
    placeholder: element.placeholder || ''
  };
  
  elementDialogVisible.value = true;
  nextTick(() => {
    if (elementFormRef.value) {
      elementFormRef.value.clearValidate();
    }
  });
};

// 对话框表单添加选项
const addOptionItem = (groupType: 'req' | 'opt' | 'normal') => {
  if (groupType === 'req' || groupType === 'normal') {
    elementForm.value.options.push('');
  } else {
    elementForm.value.optionalOptions.push('');
  }
};

// 对话框表单删除选项
const removeOptionItem = (groupType: 'req' | 'opt' | 'normal', idx: number) => {
  if (groupType === 'req' || groupType === 'normal') {
    if (elementForm.value.options.length > 1) {
      elementForm.value.options.splice(idx, 1);
    }
  } else {
    elementForm.value.optionalOptions.splice(idx, 1);
  }
};

// 🌟 选项 HTML5 原生拖曳排序状态与方法
const dragGroupType = ref<'req' | 'opt' | 'normal' | null>(null);
const dragIndex = ref<number>(-1);
const dragOverIndex = ref<number>(-1);

// 开始拖拽
const handleDragStart = (groupType: 'req' | 'opt' | 'normal', index: number, event: DragEvent) => {
  dragGroupType.value = groupType;
  dragIndex.value = index;
  if (event.dataTransfer) {
    event.dataTransfer.effectAllowed = 'move';
  }
};

// 拖拽悬悬浮划过
const handleDragOver = (groupType: 'req' | 'opt' | 'normal', index: number, event: DragEvent) => {
  if (dragGroupType.value !== groupType) return;
  dragOverIndex.value = index;
  event.preventDefault();
};

// 放置拖动并交换数组项顺序
const handleDrop = (groupType: 'req' | 'opt' | 'normal', targetIndex: number) => {
  if (dragGroupType.value !== groupType || dragIndex.value === -1 || dragIndex.value === targetIndex) {
    return;
  }
  
  const list = groupType === 'opt' ? elementForm.value.optionalOptions : elementForm.value.options;
  // 提取拖曳项
  const dragItem = list[dragIndex.value];
  // 移除
  list.splice(dragIndex.value, 1);
  // 插入
  list.splice(targetIndex, 0, dragItem);
  
  // 重置拖动状态
  dragIndex.value = -1;
  dragOverIndex.value = -1;
  dragGroupType.value = null;
};

// 结束拖拽
const handleDragEnd = () => {
  dragIndex.value = -1;
  dragOverIndex.value = -1;
  dragGroupType.value = null;
};

// 确定提交表单元素（添加或保存修改）
const confirmElementSubmit = async () => {
  if (!elementFormRef.value) return;
  
  await elementFormRef.value.validate((valid: boolean) => {
    if (valid) {
      const tabKey = currentEditingTabKey.value;
      const elements = currentCheck.value!.tabsData[tabKey];
      
      // 处理选项值：如果是单选/多选，过滤空选项
      let finalOptions: string[] = [];
      let finalOptionalOptions: string[] = [];
      if (elementForm.value.type === 'radio' || elementForm.value.type === 'checkbox') {
        finalOptions = elementForm.value.options.map(opt => opt.trim()).filter(opt => opt !== '');
        if (finalOptions.length === 0) {
          ElMessage.warning('常规选项/必检项目至少需要配置一个有效的选项值');
          return;
        }
      }
      if (elementForm.value.type === 'checkbox') {
        finalOptionalOptions = elementForm.value.optionalOptions.map(opt => opt.trim()).filter(opt => opt !== '');
      }
      
      if (isEditingElement.value) {
        // 修改旧元素
        const targetIndex = currentEditingElementIndex.value;
        if (targetIndex >= 0 && elements[targetIndex]) {
          elements[targetIndex].name = elementForm.value.name;
          elements[targetIndex].type = elementForm.value.type;
          elements[targetIndex].options = finalOptions;
          elements[targetIndex].optionalOptions = finalOptionalOptions;
          elements[targetIndex].placeholder = elementForm.value.placeholder;
          ElMessage.success('修改成功');
        }
      } else {
        // 添加新元素
        const newElem: HouseCheckElement = {
          id: 'elem_' + Date.now().toString().slice(-6),
          name: elementForm.value.name,
          type: elementForm.value.type,
          options: finalOptions,
          optionalOptions: finalOptionalOptions,
          placeholder: elementForm.value.placeholder
        };
        elements.push(newElem);
        ElMessage.success('添加成功');
      }
      
      elementDialogVisible.value = false;
    }
  });
};

// 删除单个表单元素
const deleteElement = (tabKey: string, index: number) => {
  const elements = currentCheck.value!.tabsData[tabKey];
  if (elements && elements[index]) {
    const elemName = elements[index].name;
    ElMessageBox.confirm(`确定要删除表单元素 "${elemName}" 吗？`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      elements.splice(index, 1);
      ElMessage.success('表单元素已删除');
    }).catch(() => undefined);
  }
};

// 上下移动排序表单元素
const moveElement = (tabKey: string, index: number, direction: 'up' | 'down') => {
  const elements = currentCheck.value!.tabsData[tabKey];
  if (!elements) return;
  
  if (direction === 'up' && index > 0) {
    // 与上一项交换
    const temp = elements[index];
    elements[index] = elements[index - 1];
    elements[index - 1] = temp;
  } else if (direction === 'down' && index < elements.length - 1) {
    // 与下一项交换
    const temp = elements[index];
    elements[index] = elements[index + 1];
    elements[index + 1] = temp;
  }
};

// 生命周期钩子
onMounted(() => {
  loadCheckList();
});

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, null, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "main-content",
          ref_key: "mainContentRef",
          ref: mainContentRef
        }, [
          _createElementVNode("div", {
            class: "left-panel",
            ref_key: "leftPanelRef",
            ref: leftPanelRef,
            style: _normalizeStyle({ width: leftPanelWidth.value })
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: addNewCheck
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Plus))
                    ]),
                    _: 1
                  }),
                  _cache[10] || (_cache[10] = _createTextVNode(" 新增 "))
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                circle: "",
                size: "small",
                class: "app-refresh-btn",
                onClick: loadCheckList,
                loading: listLoading.value,
                icon: _unref(Refresh),
                style: {"margin-left":"auto"},
                title: "刷新"
              }, null, 8, ["loading", "icon"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(DynamicTable, {
                data: allCheckList.value,
                model: checkTableModel.value,
                "column-labels": checkTableLabels.value,
                loading: listLoading.value,
                "show-column-selector": false,
                "show-export": false,
                "show-edit-button": true,
                "show-delete-button": true,
                pagination: checkPagination.value,
                "active-row-key": activeCheckRowKey.value,
                onEdit: handleCheckEdit,
                onDelete: handleCheckDelete,
                onFilter: handleFilter,
                onPageChange: handleCheckPageChange,
                onPageSizeChange: handleCheckPageSizeChange
              }, null, 8, ["data", "model", "column-labels", "loading", "pagination", "active-row-key"])
            ])
          ], 4),
          _createElementVNode("div", {
            class: "resize-handle",
            onMousedown: startResize
          }, null, 32),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
            (currentCheck.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      (!isEditMode.value)
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            type: "primary",
                            icon: _unref(Edit),
                            onClick: enterEditMode
                          }, {
                            default: _withCtx(() => _cache[11] || (_cache[11] = [
                              _createTextVNode(" 编辑 ")
                            ])),
                            _: 1
                          }, 8, ["icon"]))
                        : _createCommentVNode("", true),
                      (isEditMode.value)
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 1,
                            icon: _unref(Close),
                            onClick: exitEditMode
                          }, {
                            default: _withCtx(() => _cache[12] || (_cache[12] = [
                              _createTextVNode(" 取消编辑 ")
                            ])),
                            _: 1
                          }, 8, ["icon"]))
                        : _createCommentVNode("", true)
                    ]),
                    (isEditMode.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            icon: _unref(DocumentChecked),
                            onClick: saveCheckData,
                            loading: saveLoading.value
                          }, {
                            default: _withCtx(() => _cache[13] || (_cache[13] = [
                              _createTextVNode("保存数据")
                            ])),
                            _: 1
                          }, 8, ["icon", "loading"]),
                          _createVNode(_component_el_button, {
                            icon: _unref(RefreshLeft),
                            onClick: resetCurrentCheck,
                            disabled: saveLoading.value
                          }, {
                            default: _withCtx(() => _cache[14] || (_cache[14] = [
                              _createTextVNode("重置")
                            ])),
                            _: 1
                          }, 8, ["icon", "disabled"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_el_form, {
                    ref_key: "checkFormRef",
                    ref: checkFormRef,
                    model: currentCheck.value,
                    rules: checkFormRules,
                    "label-width": "120px",
                    class: "form-content"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_el_form_item, {
                          class: "check-name-item",
                          label: "体检报告名称",
                          prop: "name"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: currentCheck.value.name,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentCheck.value.name) = $event)),
                              placeholder: "请输入房屋体检报告名称",
                              readonly: !isEditMode.value,
                              style: {"width":"100%","max-width":"500px"}
                            }, null, 8, ["modelValue", "readonly"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_el_tabs, {
                          modelValue: activeTab.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeTab).value = $event)),
                          type: "border-card",
                          class: "design-tabs"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabList, (tab) => {
                              return _createVNode(_component_el_tab_pane, {
                                key: tab.key,
                                label: tab.label,
                                name: tab.key
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_11, [
                                    (isEditMode.value)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                          _createVNode(_component_el_button, {
                                            type: "success",
                                            icon: _unref(Plus),
                                            size: "small",
                                            onClick: ($event: any) => (openAddElementDialog(tab.key))
                                          }, {
                                            default: _withCtx(() => _cache[15] || (_cache[15] = [
                                              _createTextVNode(" 添加表单元素 ")
                                            ])),
                                            _: 2
                                          }, 1032, ["icon", "onClick"]),
                                          _cache[16] || (_cache[16] = _createElementVNode("span", { class: "toolbar-tip" }, "可以在表单项右侧对其进行移动、修改或删除", -1))
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_13, [
                                      (!getCurrentTabElements(tab.key).length)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                            _createVNode(_component_el_empty, {
                                              description: isEditMode.value ? '暂无表单元素，请点击上方按钮添加' : '查看模式下，当前页签暂无表单元素',
                                              "image-size": 80
                                            }, null, 8, ["description"])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getCurrentTabElements(tab.key), (element, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: element.id,
                                          class: _normalizeClass(["element-item-card", { 
                            'is-edit-mode': isEditMode.value,
                            'is-textarea': element.type === 'textarea'
                          }])
                                        }, [
                                          _createElementVNode("div", _hoisted_15, [
                                            _createElementVNode("span", _hoisted_16, _toDisplayString(element.name), 1),
                                            _createElementVNode("div", _hoisted_17, [
                                              (element.type === 'text')
                                                ? (_openBlock(), _createBlock(_component_el_input, {
                                                    key: 0,
                                                    placeholder: element.placeholder || '请输入文本',
                                                    readonly: "",
                                                    class: "preview-readonly"
                                                  }, null, 8, ["placeholder"]))
                                                : (element.type === 'number')
                                                  ? (_openBlock(), _createBlock(_component_el_input_number, {
                                                      key: 1,
                                                      "model-value": undefined,
                                                      placeholder: element.placeholder || '请输入数字',
                                                      disabled: "",
                                                      "controls-position": "right",
                                                      style: {"width":"100%","max-width":"220px"},
                                                      class: "preview-number"
                                                    }, null, 8, ["placeholder"]))
                                                  : (element.type === 'radio')
                                                    ? (_openBlock(), _createBlock(_component_el_radio_group, {
                                                        key: 2,
                                                        disabled: ""
                                                      }, {
                                                        default: _withCtx(() => [
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(element.options, (opt) => {
                                                            return (_openBlock(), _createBlock(_component_el_radio, {
                                                              key: opt,
                                                              label: opt
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(opt), 1)
                                                              ]),
                                                              _: 2
                                                            }, 1032, ["label"]))
                                                          }), 128))
                                                        ]),
                                                        _: 2
                                                      }, 1024))
                                                    : (element.type === 'checkbox')
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                                          (element.optionalOptions && element.optionalOptions.length > 0)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                                                _createElementVNode("div", _hoisted_20, [
                                                                  _cache[17] || (_cache[17] = _createElementVNode("div", { class: "column-header" }, "必检项目统计", -1)),
                                                                  _createElementVNode("div", _hoisted_21, [
                                                                    _createVNode(_component_el_checkbox_group, { disabled: "" }, {
                                                                      default: _withCtx(() => [
                                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(element.options, (opt) => {
                                                                          return (_openBlock(), _createBlock(_component_el_checkbox, {
                                                                            key: opt,
                                                                            label: opt
                                                                          }, {
                                                                            default: _withCtx(() => [
                                                                              _createTextVNode(_toDisplayString(opt), 1)
                                                                            ]),
                                                                            _: 2
                                                                          }, 1032, ["label"]))
                                                                        }), 128))
                                                                      ]),
                                                                      _: 2
                                                                    }, 1024)
                                                                  ])
                                                                ]),
                                                                _createElementVNode("div", _hoisted_22, [
                                                                  _cache[18] || (_cache[18] = _createElementVNode("div", { class: "column-header" }, "可选项目统计", -1)),
                                                                  _createElementVNode("div", _hoisted_23, [
                                                                    _createVNode(_component_el_checkbox_group, { disabled: "" }, {
                                                                      default: _withCtx(() => [
                                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(element.optionalOptions, (opt) => {
                                                                          return (_openBlock(), _createBlock(_component_el_checkbox, {
                                                                            key: opt,
                                                                            label: opt
                                                                          }, {
                                                                            default: _withCtx(() => [
                                                                              _createTextVNode(_toDisplayString(opt), 1)
                                                                            ]),
                                                                            _: 2
                                                                          }, 1032, ["label"]))
                                                                        }), 128))
                                                                      ]),
                                                                      _: 2
                                                                    }, 1024)
                                                                  ])
                                                                ])
                                                              ]))
                                                            : (_openBlock(), _createBlock(_component_el_checkbox_group, {
                                                                key: 1,
                                                                disabled: ""
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(element.options, (opt) => {
                                                                    return (_openBlock(), _createBlock(_component_el_checkbox, {
                                                                      key: opt,
                                                                      label: opt
                                                                    }, {
                                                                      default: _withCtx(() => [
                                                                        _createTextVNode(_toDisplayString(opt), 1)
                                                                      ]),
                                                                      _: 2
                                                                    }, 1032, ["label"]))
                                                                  }), 128))
                                                                ]),
                                                                _: 2
                                                              }, 1024))
                                                        ]))
                                                      : (element.type === 'textarea')
                                                        ? (_openBlock(), _createBlock(_component_el_input, {
                                                            key: 4,
                                                            type: "textarea",
                                                            rows: 2,
                                                            placeholder: element.placeholder || '请输入多行文本',
                                                            readonly: "",
                                                            class: "preview-readonly"
                                                          }, null, 8, ["placeholder"]))
                                                        : _createCommentVNode("", true)
                                            ])
                                          ]),
                                          (isEditMode.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                                _createElementVNode("div", _hoisted_25, [
                                                  _createVNode(_component_el_button, {
                                                    size: "small",
                                                    icon: _unref(ArrowUp),
                                                    title: "上移",
                                                    disabled: index === 0,
                                                    onClick: ($event: any) => (moveElement(tab.key, index, 'up'))
                                                  }, null, 8, ["icon", "disabled", "onClick"]),
                                                  _createVNode(_component_el_button, {
                                                    size: "small",
                                                    icon: _unref(ArrowDown),
                                                    title: "下移",
                                                    disabled: index === getCurrentTabElements(tab.key).length - 1,
                                                    onClick: ($event: any) => (moveElement(tab.key, index, 'down'))
                                                  }, null, 8, ["icon", "disabled", "onClick"]),
                                                  _createVNode(_component_el_button, {
                                                    size: "small",
                                                    type: "primary",
                                                    plain: "",
                                                    icon: _unref(EditPen),
                                                    title: "编辑",
                                                    onClick: ($event: any) => (openEditElementDialog(tab.key, index))
                                                  }, null, 8, ["icon", "onClick"]),
                                                  _createVNode(_component_el_button, {
                                                    size: "small",
                                                    type: "danger",
                                                    plain: "",
                                                    icon: _unref(Delete),
                                                    title: "删除",
                                                    onClick: ($event: any) => (deleteElement(tab.key, index))
                                                  }, null, 8, ["icon", "onClick"])
                                                ])
                                              ]))
                                            : _createCommentVNode("", true)
                                        ], 2))
                                      }), 128))
                                    ])
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["label", "name"])
                            }), 64))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["model"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createVNode(_component_el_empty, { description: "请先创建或选择一个房屋体检定义项" })
                ]))
          ])), [
            [_directive_loading, detailLoading.value]
          ])
        ], 512)
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: elementDialogVisible.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((elementDialogVisible).value = $event)),
      title: isEditingElement.value ? '修改表单元素' : '添加表单元素',
      width: "500px",
      "append-to-body": "",
      "close-on-click-modal": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_33, [
          _createVNode(_component_el_button, {
            onClick: _cache[8] || (_cache[8] = ($event: any) => (elementDialogVisible.value = false))
          }, {
            default: _withCtx(() => _cache[22] || (_cache[22] = [
              _createTextVNode("取消")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: confirmElementSubmit
          }, {
            default: _withCtx(() => _cache[23] || (_cache[23] = [
              _createTextVNode("确定")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "elementFormRef",
          ref: elementFormRef,
          model: elementForm.value,
          rules: elementFormRules,
          "label-width": "110px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "表单名称",
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: elementForm.value.name,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((elementForm.value.name) = $event)),
                  placeholder: "请输入表单名称 (例如: 房屋完损等级)"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "表单类型",
              prop: "type"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: elementForm.value.type,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((elementForm.value.type) = $event)),
                  placeholder: "请选择表单类型",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "文本输入框",
                      value: "text"
                    }),
                    _createVNode(_component_el_option, {
                      label: "数字输入框",
                      value: "number"
                    }),
                    _createVNode(_component_el_option, {
                      label: "单选选择框",
                      value: "radio"
                    }),
                    _createVNode(_component_el_option, {
                      label: "多选选择框",
                      value: "checkbox"
                    }),
                    _createVNode(_component_el_option, {
                      label: "文本域 (多行文本)",
                      value: "textarea"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (elementForm.value.type === 'text' || elementForm.value.type === 'number' || elementForm.value.type === 'textarea')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "预显备注"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: elementForm.value.placeholder,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((elementForm.value.placeholder) = $event)),
                      placeholder: "输入框内的提示文字，输入值后自动消失"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (elementForm.value.type === 'radio')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  label: "配置选项",
                  prop: "options"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_27, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(elementForm.value.options, (opt, optIdx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: 'radio_' + optIdx,
                          class: _normalizeClass(["option-input-row", { 'is-drag-over': dragGroupType.value === 'normal' && dragOverIndex.value === optIdx }]),
                          draggable: "true",
                          onDragstart: ($event: any) => (handleDragStart('normal', optIdx, $event)),
                          onDragover: _withModifiers(($event: any) => (handleDragOver('normal', optIdx, $event)), ["prevent"]),
                          onDragend: handleDragEnd,
                          onDrop: ($event: any) => (handleDrop('normal', optIdx)),
                          style: {"display":"flex","align-items":"center","margin-bottom":"8px","width":"100%","transition":"all 0.2s"}
                        }, [
                          _createVNode(_component_el_icon, {
                            style: {"cursor":"move","margin-right":"8px","color":"#94a3b8"},
                            title: "按住拖动排序"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Rank))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_input, {
                            modelValue: elementForm.value.options[optIdx],
                            "onUpdate:modelValue": ($event: any) => ((elementForm.value.options[optIdx]) = $event),
                            placeholder: "请输入单选选项内容",
                            style: {"flex":"1","margin-right":"8px"}
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                          _createVNode(_component_el_button, {
                            type: "danger",
                            link: "",
                            icon: _unref(Delete),
                            title: "删除选项",
                            onClick: ($event: any) => (removeOptionItem('normal', optIdx)),
                            disabled: elementForm.value.options.length <= 1
                          }, null, 8, ["icon", "onClick", "disabled"])
                        ], 42, _hoisted_28))
                      }), 128)),
                      _createVNode(_component_el_button, {
                        type: "primary",
                        plain: "",
                        size: "small",
                        icon: _unref(Plus),
                        style: {"margin-top":"4px"},
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (addOptionItem('normal')))
                      }, {
                        default: _withCtx(() => _cache[19] || (_cache[19] = [
                          _createTextVNode(" 添加单选选项 ")
                        ])),
                        _: 1
                      }, 8, ["icon"])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (elementForm.value.type === 'checkbox')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createVNode(_component_el_form_item, {
                    label: "必检项目统计",
                    prop: "options"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_29, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(elementForm.value.options, (opt, optIdx) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: 'req_' + optIdx,
                            class: _normalizeClass(["option-input-row", { 'is-drag-over': dragGroupType.value === 'req' && dragOverIndex.value === optIdx }]),
                            draggable: "true",
                            onDragstart: ($event: any) => (handleDragStart('req', optIdx, $event)),
                            onDragover: _withModifiers(($event: any) => (handleDragOver('req', optIdx, $event)), ["prevent"]),
                            onDragend: handleDragEnd,
                            onDrop: ($event: any) => (handleDrop('req', optIdx)),
                            style: {"display":"flex","align-items":"center","margin-bottom":"8px","width":"100%","transition":"all 0.2s"}
                          }, [
                            _createVNode(_component_el_icon, {
                              style: {"cursor":"move","margin-right":"8px","color":"#94a3b8"},
                              title: "按住拖动排序"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Rank))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_input, {
                              modelValue: elementForm.value.options[optIdx],
                              "onUpdate:modelValue": ($event: any) => ((elementForm.value.options[optIdx]) = $event),
                              placeholder: "请输入必检项目内容",
                              style: {"flex":"1","margin-right":"8px"}
                            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                            _createVNode(_component_el_button, {
                              type: "danger",
                              link: "",
                              icon: _unref(Delete),
                              title: "删除",
                              onClick: ($event: any) => (removeOptionItem('req', optIdx)),
                              disabled: elementForm.value.options.length <= 1
                            }, null, 8, ["icon", "onClick", "disabled"])
                          ], 42, _hoisted_30))
                        }), 128)),
                        _createVNode(_component_el_button, {
                          type: "primary",
                          plain: "",
                          size: "small",
                          icon: _unref(Plus),
                          style: {"margin-top":"4px"},
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (addOptionItem('req')))
                        }, {
                          default: _withCtx(() => _cache[20] || (_cache[20] = [
                            _createTextVNode(" 添加必检项目 ")
                          ])),
                          _: 1
                        }, 8, ["icon"])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "可选项目统计",
                    prop: "optionalOptions"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_31, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(elementForm.value.optionalOptions, (opt, optIdx) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: 'opt_' + optIdx,
                            class: _normalizeClass(["option-input-row", { 'is-drag-over': dragGroupType.value === 'opt' && dragOverIndex.value === optIdx }]),
                            draggable: "true",
                            onDragstart: ($event: any) => (handleDragStart('opt', optIdx, $event)),
                            onDragover: _withModifiers(($event: any) => (handleDragOver('opt', optIdx, $event)), ["prevent"]),
                            onDragend: handleDragEnd,
                            onDrop: ($event: any) => (handleDrop('opt', optIdx)),
                            style: {"display":"flex","align-items":"center","margin-bottom":"8px","width":"100%","transition":"all 0.2s"}
                          }, [
                            _createVNode(_component_el_icon, {
                              style: {"cursor":"move","margin-right":"8px","color":"#94a3b8"},
                              title: "按住拖动排序"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Rank))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_input, {
                              modelValue: elementForm.value.optionalOptions[optIdx],
                              "onUpdate:modelValue": ($event: any) => ((elementForm.value.optionalOptions[optIdx]) = $event),
                              placeholder: "请输入可选项目内容 (不填则不渲染两栏)",
                              style: {"flex":"1","margin-right":"8px"}
                            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                            _createVNode(_component_el_button, {
                              type: "danger",
                              link: "",
                              icon: _unref(Delete),
                              title: "删除",
                              onClick: ($event: any) => (removeOptionItem('opt', optIdx))
                            }, null, 8, ["icon", "onClick"])
                          ], 42, _hoisted_32))
                        }), 128)),
                        _createVNode(_component_el_button, {
                          type: "primary",
                          plain: "",
                          size: "small",
                          icon: _unref(Plus),
                          style: {"margin-top":"4px"},
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (addOptionItem('opt')))
                        }, {
                          default: _withCtx(() => _cache[21] || (_cache[21] = [
                            _createTextVNode(" 添加可选项目 ")
                          ])),
                          _: 1
                        }, 8, ["icon"])
                      ])
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})